import { Component, OnInit } from '@angular/core';
import { NavBarComponent } from '../nav-bar/nav-bar.component';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { QuickDialog } from '../utilities/Dialog/QuickDialog';
import { UserService } from '../services/user-service/user.service';
import { MatDialog } from '@angular/material';
import { FormUtils } from '../utilities/FormUtils/FormUtils';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-claim-account',
  templateUrl: './claim-account.component.html',
  styleUrls: ['./claim-account.component.css']
})
export class ClaimAccountComponent implements OnInit {

  infoForm: FormGroup;
  navOptions = NavBarComponent.standard;
  passwordInvalid;
  emailTaken = false;
  user = null;

  constructor(private router:Router, private formBuilder: FormBuilder, private userService: UserService, private dialog: MatDialog, private route: ActivatedRoute) {
    this.infoForm = this.formBuilder.group({
      email: [null, [Validators.required, Validators.email]],
      employeeid: [null, Validators.required],
      password: [null, [Validators.required, Validators.minLength(6)]],
      confirmpassword: [null, [Validators.required, Validators.minLength(6)]],
    })
  }



  ngOnInit() {
    if (this.route.snapshot.queryParams.data) {
      var d = new QuickDialog(this.dialog).LoadingDialog("Please wait...");
      this.userService.decodeRidePass(this.route.snapshot.queryParams.data).then((res) =>{
        d.close();
        this.user = res;
      }).catch(e =>{
        d.close();
        new QuickDialog(this.dialog).InfoDialog(e._body,"Unable Load Account","OK");
        console.log(e);
      })
    } 
  }

  checkEmailTaken(): Promise<boolean> {
    if (!this.infoForm.getRawValue().email) {
      return;
    }
    //this.basicInfoNextButton.disabled = true;
    return new Promise((resolve, reject) => {

      this.userService.checkEmailExist(this.infoForm.getRawValue().email).then((res: any) => {

        if (res.status) {
          if (res.data) {
            this.emailTaken = true;
            resolve(true);
          } else {
            this.emailTaken = false;
            resolve(false);
          }
        } else {
          reject(res.message);
        }

      }).catch(e => {
        console.log(e);
        try {
          if (e.status) {
            var body = JSON.parse(e._body);
            new QuickDialog(this.dialog).InfoDialog(body.message, "", "OK");
          }
        } catch (ex) {
          reject(ex);
        }
        reject(e);
      })
    })

  }

  passwordValid() {
    var form = this.infoForm.getRawValue();
    var valid = true;
    if (form.password != form.confirmpassword) {
      this.passwordInvalid = "Password and confirm password fields must match";
      valid = false;
    }
    return valid;
  }

  claim() {
    this.passwordInvalid = false;
    FormUtils.markFormGroupTouched(this.infoForm);
    if (this.passwordValid() && this.infoForm.valid) {
      var payload = this.infoForm.getRawValue();
      payload.user = this.user.userid;
      var d = new QuickDialog(this.dialog).LoadingDialog("Claiming Account...");
      this.userService.claim(payload).then((res) =>{
        d.close();
        console.log(res);
        new QuickDialog(this.dialog).InfoDialog(`Your account has been claimed, you may now log in using ${payload.email} and the password you just set up.`,"Success","Go To Login").then(() =>{
          this.router.navigate(['/user/login']);
        })
      }).catch(e =>{
        new QuickDialog(this.dialog).InfoDialog(e._body,"Unable Claim Account","OK");
        d.close();
        console.log(e)
      });
    }
  }

}
